import React from 'react';
import { Box } from "@mui/material";
import { VendorAISummary, VendorAIProfileProps } from "./vendor-ai-summary";

export const VendorAIProfile: React.FC<VendorAIProfileProps> = (props) => {
  return (
    <Box sx={{ width: '100%' }}>
      <VendorAISummary {...props} />
    </Box>
  );
};

export default VendorAIProfile;
